export const ALERT_SUCCESS_THEME = 'ALERT_SUCCESS_THEME';
export const ALERT_ERROR_THEME = 'ALERT_ERROR_THEME';
export const ALERT_OFFLINE_THEME = 'ALERT_OFFLINE_THEME';
export const ALERT_SYSTEMINFO_THEME = 'ALERT_SYSTEMINFO_THEME';
export const ALERT_WARNING_THEME = 'ALERT_WARNING_THEME';



// WEBPACK FOOTER //
// ./src/constants/alertBannerThemes.js